export default __webpack_public_path__ + "static/media/gallery_08.175fac60.jpg";